interface Translations {
    [section: string]: {
        [key: string]: string
    }
}

export interface Messages<T extends Translations> {
    getText<Section extends keyof T, Key extends keyof T[Section]>(section: Section, key: Key, ...args: any[]): string
    getError<Key extends keyof T['errors']>(key: Key, ...args: any[]): Error
}

class StaticTextHandler<T extends Translations> implements Messages<T> {
    private fileContent: T

    public constructor(fileContent: T) {
        this.fileContent = fileContent

        this.getText = this.getText.bind(this)
        this.getError = this.getError.bind(this)
    }

    public getText<Section extends keyof T, Key extends keyof T[Section]>(section: Section, key: Key, ...args: any[]) {
        if (!this.fileContent[section][key]) {
            console.log(`Error: Cannot find text message [${String(section)}][${String(key)}]`)
            return ''
        }
        const mappedArgs = args.map(a => (typeof a === 'object' ? JSON.stringify(a) : a))

        return this.fileContent[section][key].replace(/{(\d+)}/g, (match, number) =>
            typeof mappedArgs[number] !== 'undefined' ? mappedArgs[number] : match
        )
    }

    public getError<Key extends keyof T['errors']>(key: Key, ...args: any[]) {
        return new Error(this.getText('errors', key, ...args))
    }
}

export function getTexts<T extends Translations>(file: T): Messages<T> {
    if (!file) {
        throw Error('Text file is not defined')
    }

    return new StaticTextHandler<T>(file)
}
